// extracted by mini-css-extract-plugin
export default {"row":"newsList_row__31HoL","grid":"newsList_grid__lzAlt","mainInfo":"newsList_mainInfo__Khy9x","mainInfoCard":"newsList_mainInfoCard__hdWQV","flex":"newsList_flex__ohPcc"};